function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 text-center py-4 border-t border-gray-700">
      <p>© 2025 Luis Torre</p>
      <p className="mt-2 space-x-2">
        <a
          href="https://github.com/ljtorrer"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white transition"
        >
          GitHub
        </a>
        <span>|</span>
        <a
          href="https://linkedin.com/in/ljtorrer"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white transition"
        >
          LinkedIn
        </a>
      </p>
    </footer>
  );
}

export default Footer;
